var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBCabinetWalletSwapIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6615 12.2435H19.8721C20.8767 10.0145 21.9127 8.31929 22.8859 7.22052H0V4.99157H22.8859C21.8813 3.8928 20.8767 2.19755 19.8721 0H21.6615C23.8591 2.57427 26.1822 4.45788 28.5681 5.68223V6.56125C26.1822 7.7856 23.8591 9.66921 21.6615 12.2435ZM6.90658 24.487C4.70903 21.9127 2.38591 20.0291 0 18.8047V17.9257C2.38591 16.7014 4.70903 14.8178 6.90658 12.2435H8.69601C7.69142 14.441 6.68682 16.1363 5.68223 17.2351H28.5681V19.464H5.68223C6.65543 20.5628 7.69142 22.258 8.69601 24.487H6.90658Z",
    fill: "#FF592E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCabinetWalletSwapIcon);
export default __webpack_public_path__ + "static/media/b_cabinet_wallet_swap_icon.027bbc55a3d6af2404ab44bcf8037aca.svg";
export { ForwardRef as ReactComponent };